import React, { useCallback, useEffect, useState } from "react";
import { Timer, Description, Send, Delete, Edit } from "@material-ui/icons";
import { IconButton, Tooltip } from "@material-ui/core/";
import Alert from "react-s-alert";
/********** COMPONENTS **********/
import ConfirmationElement from "component/ConfirmationElement";
import LoadingSpinner from "component/LoadingSpinner";
import AlertElement from "component/AlertElement";
import NotAuthorized from "common/NotAuthorized";
import PackageDetail from "./PackageDetail";
import EditPackage from "./EditPackage";
import Footer from "page/Home/Footer2";
import Table from "component/Table";
/********** SERVICES **********/
import ApiServices from "service/ApiServices";
/********** STYLES **********/
import { useStyles } from "./style";

export default function PaquetesCreados(props) {
  /********** VARIABLES **********/
  const classes = useStyles();
  const dataOp = props.dataOp;
  const controller = "paquetesDeAfiliacionYAdhesion";
  const [elementAlertModal, setElementAlertModal] = useState({
      openAlert: false,
      titleAlert: "",
      typeAlert: "",
    }),
    [loadingSpinner, setLoadingSpinner] = useState({
      openLoading: false,
      message: "",
    }),
    [openDetailPackage, setOpenDetailPackage] = useState(false),
    [openDeletePackage, setOpenDeletePackage] = useState(false),
    [openEditPackage, setOpenEditPackage] = useState(false),
    [openSendPackage, setOpenSendPackage] = useState(false),
    [detailPackage, setDetailPackage] = useState([]),
    [authorized, setAuthorized] = useState(true),
    [idPackage, setIdPackage] = useState(""),
    [data, setData] = useState([]),
    [tableOptions] = useState({
      pageSize: 20,
      pageSizeOptions: [20, 30, 50, 75, 100],
      toolbar: true,
      paging: true,
      filtering: true,
      search: true,
      actionsColumnIndex: -1,
    }),
    [tableHeader] = useState([
      {
        title: "Identificador del paquete",
        field: "id",
        cellStyle: { height: "50px" },
      },
      { title: "Nombre del paquete", field: "name" },
      { title: "Hojas en el paquete", field: "totalHojas" },
      { title: "Fecha de creacion", field: "fechaCreacion" },
      {
        title: "Estado",
        field: "estado",
        filtering: false,
        render: () => (
          <div style={{ minWidth: "100px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Timer style={{ color: "#5dade2" }} /> EN PROCESO
            </div>
          </div>
        ),
      },
      {
        title: "Acciones",
        field: "acciones",
        filtering: false,
        render: (rowData) => (
          <div
            className={classes.actionContainer}
            style={{ minWidth: "200px" }}
          >
            <div className={classes.iconButtonContainer}>
              <Tooltip
                title="Detalle Paquete"
                onClick={() => showDetailPackageModal(rowData)}
              >
                <IconButton
                  className={classes.iconStyles}
                  size="small"
                  color="primary"
                >
                  <Description />
                </IconButton>
              </Tooltip>
            </div>
            <div className={classes.iconButtonContainer}>
              <Tooltip
                title="Editar Nombre"
                onClick={() => handleOpenEditPackage(rowData.id)}
              >
                <IconButton
                  className={classes.iconStyles}
                  size="small"
                  color="primary"
                >
                  <Edit />
                </IconButton>
              </Tooltip>
            </div>
            <div className={classes.iconButtonContainer}>
              <Tooltip
                title="Enviar"
                onClick={() => handleOpenSendModal(rowData)}
              >
                <IconButton
                  className={classes.iconStyles}
                  size="small"
                  color="primary"
                >
                  <Send />
                </IconButton>
              </Tooltip>
            </div>
            <div className={classes.iconButtonContainer}>
              <Tooltip
                title="Eliminar"
                onClick={() => handleOpenDeleteModal(rowData)}
              >
                <IconButton
                  className={classes.iconStyles}
                  size="small"
                  color="secondary"
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        ),
      },
    ]);

  /********** COMPONENTS **********/
  /*  Este método lista la información de los paquetes en estado 0 - Disponible y que sean de faseOP 3 - Partido Politico
        se ejecuta en el useEffect y en el "refreshList"   */
  const showList = useCallback(async () => {
    setLoadingSpinner({
      ...loadingSpinner,
      openLoading: true,
      message: "Obteniendo paquetes creados...",
    });
    try {
      const hasPermission = await ApiServices.userSecurity.hasPermission(
        controller,
        "list"
      );
      if (hasPermission.error) {
        setAuthorized(false);
        setLoadingSpinner({ ...loadingSpinner, openLoading: false });
        setElementAlertModal({
          openAlert: true,
          titleAlert: "Permisos Insuficientes, consulte con soporte.",
          typeAlert: "error",
        });
      } else {
        let response = await ApiServices[controller].getListPackageOp(
          dataOp.idOrganizacion,
          1,
          3
        );
        if (response.error !== null) {
          setElementAlertModal({
            openAlert: true,
            titleAlert: response.error.message,
            typeAlert: "error",
          });
        } else if (response.data !== "") {
          setData(response.data);
        }
        setAuthorized(true);
        setLoadingSpinner({ ...loadingSpinner, openLoading: false });
      }
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({ ...loadingSpinner, openLoading: false });
    }
  }, []);

  useEffect(() => {
    showList();
  }, [showList]);

  /********** FUNCIONES PARA VER DETALLES DEL PAQUETE **********/
  /*  Este método despliega el modal "PackageDetail" que contiene la informacion detallada del paquete que seleccionemos, se ejecuta desde el botón
        "Detalle" en la fila de cada paquete de la tabla */
  const showDetailPackageModal = (rowData) => {
    setOpenDetailPackage(true);
    setDetailPackage(rowData);
  };

  /* El metodo cierra el modal "PackageDetail" y actualiza la informacion de los paquetes */
  const updateDetailPackageModal = () => {
    setOpenDetailPackage(false);
    setElementAlertModal({
      openAlert: true,
      titleAlert: "HOJA REMOVIDA DEL PAQUETE",
      typeAlert: "success",
    });
    showList();
  };

  /*  El método cierra el modal "PackageDetail" se ejecuta desde el mismo componente en el botón "Cancelar" */
  const closeDetailPackageModal = () => {
    setOpenDetailPackage(false);
  };

  /********** FUNCIONES PARA EDITAR EL PAQUETE **********/
  /*  Este método despliega el modal "EditPackage" que tiene el formulario para cambiar el nombre que tiene el paquete, se ejecuta desde
        el botón de "Editar nombre" en la fila de cada paquete de la tabla */
  const handleOpenEditPackage = (rowId) => {
    setIdPackage(rowId);
    setOpenEditPackage(true);
  };

  /*  Este método muestra la alerta indicando que el nombre del paquete fue actualizado correctamente, se ejectua desde el componente
        "EditPackage" */
  const editPackageSuccess = () => {
    setOpenEditPackage(false);
    setElementAlertModal({
      openAlert: true,
      titleAlert: "NOMBRE DE PAQUETE ACTUALIZADO",
      typeAlert: "success",
    });
    showList();
  };

  /*  Este método cierra el modal "EditPackage" para editar el nombre del paquete, se ejecuta desde este componente */
  const cancelEditPackage = () => {
    setOpenEditPackage(false);
  };

  /********** FUNCIONES PARA ENVIAR EL PAQUETE **********/
  /*  El método abre el modal "ConfirmationElement" que se usa para el envío del paquete, valida que el paquete no se encuentre vacío,
        se ejecuta desde el botón "Enviar" en cada fila de los paquetes de la tabla */
  const handleOpenSendModal = (rowData) => {
    if (rowData.totalHojas === 0) {
      setElementAlertModal({
        openAlert: true,
        titleAlert: "El paquete está vacío, agregue hojas primero.",
        typeAlert: "error",
      });
    } else {
      setIdPackage(rowData.id);
      setOpenSendPackage(true);
    }
  };

  /*  El método cierra el modal "ConfirmationElement" que se usa para el envío del paquete, se ejecuta en el método "sendPackage" y
        desde el modal cuando presionan el botón "Cancelar" */
  const closeSendModal = () => {
    setOpenSendPackage(false);
  };

  /*  Este método realiza el envío del paquete cambiando el estado del paquete que se haya seleccionado, se ejecuta desde 
        el botón "Confirmar" en el modal "ConfirmationElement" que se usa para el envío del paquete, si se ejecuta correctamente
        actualiza toda la información de la tabla. */
  const sendPackage = async () => {
    setLoadingSpinner({
      ...loadingSpinner,
      openLoading: true,
      message: "Enviando paquete...",
    });
    try {
      closeSendModal();
      let response =
        await ApiServices.paquetesDeAfiliacionYAdhesion.enviarPaquete(
          idPackage
        );
      if (response.error !== null) {
        setElementAlertModal({
          openAlert: true,
          titleAlert: response.error.message,
          typeAlert: "error",
        });
      } else {
        setElementAlertModal({
          openAlert: true,
          titleAlert: "Paquete enviado correctamente",
          typeAlert: "success",
        });
        showList();
      }
      setLoadingSpinner({ ...loadingSpinner, openLoading: false });
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({ ...loadingSpinner, openLoading: false });
    }
  };

  /********** FUNCIONES PARA ELIMINAR EL PAQUETE **********/
  /*  El método muestra el modal "ConfirmationElement" que se usa para eliminar el paquete, si el paquete contiene hojas
        no permite mostrar el modal, se ejecuta desde el botón "Eliminar" de cada fila de paquetes en la tabla */
  const handleOpenDeleteModal = (rowData) => {
    if (rowData.totalHojas > 0) {
      setElementAlertModal({
        openAlert: true,
        titleAlert:
          "No puede eliminar un paquete con hojas, remueva las hojas primero.",
        typeAlert: "error",
      });
    } else {
      setIdPackage(rowData.id);
      setOpenDeletePackage(true);
    }
  };

  /*  El método cierra el modal "ConfirmationElement" que se usa para eliminar el paquete, se ejecuta en el método "deletePackage" y
        desde el modal cuando presionan el botón "Cancelar" */
  const closeDeleteModal = () => {
    setOpenDeletePackage(false);
  };

  /*  Este método elimina el paquete, se ejecuta desde el botón "Confirmar" en el modal "ConfirmationElement" que se usa para eliminar 
        el paquete, si se ejecuta correctamente actualiza toda la información de la tabla. */
  const deletePackage = async () => {
    setLoadingSpinner({
      ...loadingSpinner,
      openLoading: true,
      message: "Enviando paquete...",
    });
    try {
      closeDeleteModal();
      let response =
        await ApiServices.paquetesDeAfiliacionYAdhesion.eliminarPaquete(
          idPackage
        );
      if (response.error !== null) {
        setElementAlertModal({
          openAlert: true,
          titleAlert: response.error.message,
          typeAlert: "error",
        });
      } else {
        setElementAlertModal({
          openAlert: true,
          titleAlert: "Paquete eliminado",
          typeAlert: "success",
        });
        showList();
      }
      setLoadingSpinner({ ...loadingSpinner, openLoading: false });
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({ ...loadingSpinner, openLoading: false });
    }
  };

  /* Este método cierra el modal "AlertElement" de mensajes de alerta */
  const handCloseAlertModal = () => {
    setElementAlertModal({ ...elementAlertModal, openAlert: false });
  };

  /********** RENDER **********/
  if (!authorized) {
    return <NotAuthorized />;
  }

  return (
    <div>
      {loadingSpinner.openLoading && (
        <LoadingSpinner
          open={loadingSpinner.openLoading}
          message={loadingSpinner.message}
        />
      )}
      {elementAlertModal.openAlert && (
        <AlertElement
          typeAlert={elementAlertModal.typeAlert}
          openModal={elementAlertModal.openAlert}
          title={elementAlertModal.titleAlert}
          handCloseModal={handCloseAlertModal}
        />
      )}
      {openDetailPackage && (
        <PackageDetail
          open={openDetailPackage}
          handCloseModal={closeDetailPackageModal}
          updateModal={updateDetailPackageModal}
          data={detailPackage}
        />
      )}
      {openEditPackage && (
        <EditPackage
          open={openEditPackage}
          handleClose={cancelEditPackage}
          requestSuccess={editPackageSuccess}
          idPackage={idPackage}
        />
      )}
      {openSendPackage && (
        <ConfirmationElement
          open={openSendPackage}
          handleClose={closeSendModal}
          handleConfirm={sendPackage}
          titleModal="¿Quiere enviar el paquete para su depuración?"
          subtitleModal={
            "Al enviar el paquete no podrá modificar su información."
          }
        />
      )}
      {openDeletePackage && (
        <ConfirmationElement
          open={openDeletePackage}
          handleClose={closeDeleteModal}
          handleConfirm={deletePackage}
          titleModal={"¿Quiere eliminar el paquete " + idPackage + "?"}
        />
      )}
      <Table
        title={"Listado de paquetes"}
        header={tableHeader}
        data={data}
        options={tableOptions}
        refreshList={showList}
      />
      <Footer />
    </div>
  );
}
